var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCameraZoomMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.43018 5.69711L12.0729 4.72104L13.049 8.36378",
    stroke: "#2264C2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7383 5.29688L9.40495 9.33833",
    stroke: "#2264C2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.38036 16.4474L4.73763 17.4235L3.76156 13.7808",
    stroke: "#2264C2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.07227 16.8477L7.4056 12.8062",
    stroke: "#2264C2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5759 28.3295C19.6273 28.2403 19.7594 28.0115 19.8926 27.7809C20.1191 27.3885 20.4722 27.0846 20.894 26.9191L21.7711 26.5749C22.5526 26.2141 23.2319 25.6711 23.7542 24.9957C23.8383 24.913 23.9127 24.8177 23.9746 24.7107L25.9746 21.2466C26.3428 20.6088 26.1243 19.7934 25.4865 19.4252C25.0291 19.1611 24.4803 19.1988 24.0707 19.4766L24.4469 18.825C24.8151 18.1872 24.5966 17.3718 23.9589 17.0036C23.3211 16.6354 22.5057 16.8539 22.1375 17.4916C22.5057 16.8539 22.2872 16.0384 21.6495 15.6703C21.0121 15.3023 20.1973 15.5203 19.8287 16.1572L22.4948 11.5395C22.8629 10.9018 22.6444 10.0863 22.0067 9.71812C21.369 9.34993 20.5535 9.56843 20.1854 10.2062L15.9262 17.5833C15.7621 17.3884 15.6277 17.1683 15.5292 16.9296L14.523 14.4916C14.3201 14 13.8265 13.6923 13.2958 13.7265C12.5141 13.7769 11.974 14.5298 12.1767 15.2864L13.005 18.3774L13.6903 20.6416C13.8701 21.2354 13.8913 22.1753 13.6476 22.5974C13.2247 23.33 13.0109 23.7004 12.6476 24.3295",
    stroke: "#8CB5F0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4727 18.6484L22.1393 17.4937",
    stroke: "#8CB5F0",
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1621 17.3125L19.8288 16.1578",
    stroke: "#8CB5F0",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraZoomMobile);
export default __webpack_public_path__ + "static/media/CameraZoomMobile.39aeba2399d82188ebaa63c82fad6d0a.svg";
export { ForwardRef as ReactComponent };